export default __webpack_public_path__ + "static/media/farm_table.e744f9da.webp";